import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MondelezService } from 'src/app/shared/services/mondelez.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-scenario-view-dialog',
  templateUrl: './scenario-view-dialog.component.html',
  styleUrls: ['./scenario-view-dialog.component.scss'],
})
export class ScenarioViewDialogComponent {
  public scenarioForm: FormGroup;
  public enableEdit = false;

  constructor(
    private mondelezService: MondelezService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ScenarioViewDialogComponent>,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  private createForm() {
    this.scenarioForm = this.fb.group({
      scenario_id: [this.data['scenario'].scenario_id],
      parent_scenario_id: [this.data['scenario'].parent_scenario_id],
      scenario_name: [this.data['scenario'].scenario_name],
      scenario_description: [this.data['scenario'].scenario_description],
      created_by: [this.data['scenario'].created_by],
      created_at: [this.updateDataFormat(this.data['scenario'].created_at)!],
      iteration_last_updated: [this.data['scenario'].iteration_last_updated ? this.updateDataFormat(this.data['scenario'].iteration_last_updated)! : 'N/A'],
      iteration_code: [this.data['scenario'].iteration_code],
    });

    // this.scenarioForm.get('scenario_name')?.disable();
    // this.scenarioForm.get('scenario_description')?.disable();
  }

  onEnableEdit() {
    this.enableEdit = true;
    // this.scenarioForm.get('scenario_name')?.enable();
    // this.scenarioForm.get('scenario_description')?.enable();
  }

  onUpdateScenario() {
    // console.log('object :>> ', this.scenarioForm.value);
    if (this.scenarioForm.invalid) {
      return;
    }
    this.mondelezService.updateScenario(this.scenarioForm.value).subscribe(
      (res) => {
        if (res['response'] === 'SUCCESS') {
          this.dialogRef.close(true);
        }
      },
      (err) => {
        console.log('Error', err);
      }
    );
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onGoBack() {
    this.dialogRef.close();
  }

  updateDataFormat(dateObj) {
    const date = new Date(dateObj);
    return this.datePipe.transform(date, 'EEEE, MMMM dd, yyyy')!;
  }
}
